import { IFolderContent } from '../../interfaces/Folder'

export const FolderDefaultState: IFolderContent = {
  civilite: '',
  nationalite_principale: '',
  nationalite_secondaire: '',
  sexe: '',
  nom: '',
  prenom: '',
  nom_patronimique: '',
  nom_usage: '',
  prenom_usage: '',
  prenom1: '',
  prenom2: '',
  prenom3: '',
  date_naissance: '',
  pays_naissance: '',
  lieu_naissance: '',
  email: '',
  telephone: '',
  identity_document_type: '',
  other_input_type: '',
  professional_category: '',
  professional_subcategory: '',
  secteur_activite: '',
  profession: '',
  csp_niv3: '',
  no_revenue: '',
  revenue: [],
  no_patrimony: '',
  patrimony_types: [],
  telephone_mobile_1_num: '',
  telephone_mobile_2_num: '',
  telephone_mobile_3_num: '',
  situation_logement: '',
  host_identity_document_type: '',
  host_other_input_type: '',
  existing_address: '',
  existing_identity: '',
  fiscal_address_country: '',
  is_tax_country_france: '',
  tax_country_other: '',
  situation_monegasque: '',
  type_fr_raison_domicile_different: '',
  nif_is_available: '',
  nif: '',
  motif_absence_nif: '',
  autre_motif_absence_nif: '',
  autre_fr_raison_domicile_different: '',
  nationalite_americaine: '',
  is_nee_usa: '',
  american_tax_input: '',
  tin: '',
  attestation_obntention_tin: '',
  signature_mobile_phone: '',
  signature_terms_and_conditions: '',
  journeyStatus: '',
  score_secu_fin: '',
  validation_terms_and_conditions: '',
  pays_residence_ficale: '',
  statusWorkflow: 10200,
  top_jdi: '',
  commune_naissance: '',
  departement_naissance: '',
  fiscal_address_country_2: '',
  is_tax_country_france_2: '',
  tax_country_other_2: '',
  situation_monegasque_2: '',
  type_fr_raison_domicile_different_2: '',
  nif_is_available_2: '',
  nif_2: '',
  motif_absence_nif_2: '',
  autre_motif_absence_nif_2: '',
  autre_fr_raison_domicile_different_2: '',
  nationalite_americaine_2: '',
  is_nee_usa_2: '',
  american_tax_input_2: '',
  tin_2: '',
  attestation_obntention_tin_2: '',
  pays_residence_ficale_2: '',
  existing_fiscal_periodique_2: '',
  identifiant_fiscale_2: '',
}
